import * as Styled from "./style";
import { useAuth } from "~/provider/auth";

export const PurchasePointBlock = () => {
  const { isLoggedIn, wallet } = useAuth();
  const totalPoint = wallet === undefined ? 0 : wallet.dmmPoint.paidDmmPoint + wallet.dmmPoint.sharedFreeDmmPoint;

  if (!isLoggedIn) return null;

  return (
    <Styled.DivRootContainer>
      <Styled.ParContentsHead>総保有ポイント</Styled.ParContentsHead>
      <Styled.ParContentsValue>
        <Styled.PointIcon name="premiumPoint" color="YELLOW900" />
        <Styled.PointValue>{totalPoint.toLocaleString()}</Styled.PointValue>pt
      </Styled.ParContentsValue>
    </Styled.DivRootContainer>
  );
};
